import { Component, Input, OnInit } from '@angular/core';
import { AccessDeniedLogEntry } from 'src/app/classes';
import { BackEndService } from 'src/app/backend-service';

@Component({
  selector: 'app-deny-access',
  templateUrl: './deny-access.component.html',
  styleUrls: ['./deny-access.component.css']
})
export class DenyAccessComponent implements OnInit {

  @Input() source: string;
  @Input() requirements: string[];
  logGuid: string = null;

  constructor(private backEndService: BackEndService) { }

  ngOnInit() {
    let log = new AccessDeniedLogEntry();
    log.logcomponent = "amsadminclient,get," + this.source;
    log.logrules = this.requirements.join(",");
    this.backEndService.post(AccessDeniedLogEntry.url, log).subscribe((guid: string) => {
      this.logGuid = guid;
    });
  }

}
